import FirstLetterIndex from '../../lib/HamCallsignDB/callsignindexone.json';
import SecondLetterIndex from '../../lib/HamCallsignDB/callsignindextwo.json';
import ThirdLetterIndex from '../../lib/HamCallsignDB/callsignindexthree.json';
import FourthLetterIndex from '../../lib/HamCallsignDB/callsignindexfour.json';

var getAmateurRadioInfoByCallsign = function getAmateurRadioInfoByCallsign(callsign) {
  if (typeof callsign !== 'string') {
    console.error('[callsign.js]: Callsign must be string');
    return;
  }

  callsign = callsign.toUpperCase();
  var result1 = FirstLetterIndex.find(function (x) {
    return x.prefix === callsign.substring(0, 1);
  });
  var result2 = SecondLetterIndex.find(function (x) {
    return x.prefix === callsign.substring(0, 2);
  });
  var result3 = ThirdLetterIndex.find(function (x) {
    return x.prefix === callsign.substring(0, 3);
  });
  var result4 = FourthLetterIndex.find(function (x) {
    return x.prefix === callsign.substring(0, 4);
  });
  var result;

  if (result4 === undefined) {
    if (result3 === undefined) {
      if (result2 === undefined) {
        if (result1 === undefined) {
          result = undefined;
        } else {
          result = result1;
        }
      } else {
        result = result2;
      }
    } else {
      result = result3;
    }
  } else {
    result = result4;
  }

  return result;
};

export default getAmateurRadioInfoByCallsign;